import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

import AButtonPrimary from '@/components/atoms/AButtonPrimary.vue'
	import AButtonSecondary from '@/components/atoms/AButtonSecondary.vue'
	import AButtonIcon from '@/components/atoms/AButtonIcon.vue'

	import type { ObjectContext } from '@/global'
	import { reactive, computed, watch } from 'vue'
	import { useGeneral } from '@/hooks'

	
export default /*#__PURE__*/_defineComponent({
  props: {
		modelValue: { type: Boolean, default: false },
		id: { type: String, default: '' },
		title: { type: String, default: '' },
		icon: { type: String, default: '' },
		iconColor: { type: String, default: '' },
		report: { type: String, default: '' },
		action: { type: String, default: 'Action_save' },
		resetAction: { type: String, default: 'Action_reset' },
		loading: { type: Boolean, default: false },
		disabled: { type: Boolean, default: false },
		reset: { type: Boolean, default: false },
		premium: { type: Boolean, default: false },
		noActions: { type: Boolean, default: false },
		noClose: { type: Boolean, default: false },
		emitDelete: { type: Boolean, default: false },
		width: { type: String, default: '' },
		small: { type: Boolean, default: false },
		medium: { type: Boolean, default: false },
		large: { type: Boolean, default: false }
	},
  emits: ['update:modelValue', 'delete', 'reset', 'cancel', 'submit'],
  setup(__props, { emit: $emit }) {

const $props = __props

	const { $store, icons } = useGeneral()

	
	

	const state = reactive({
		dialog: false
	})

	function init() {
		state.dialog = $props.modelValue
	}
	init()

	watch(
		() => $props.modelValue,
		(val: boolean) => (state.dialog = val)
	)

	const width = computed(() => ($props.width ? $props.width : $props.small ? 500 : $props.medium ? 800 : $props.large ? 1400 : ''))

	function onClose() {
		$emit('update:modelValue', false)
	}
	function onDelete() {
		$emit('delete', false)
	}
	function onReset() {
		$emit('reset', false)
	}
	function onCancel() {
		return $props.noClose ? $emit('cancel') : onClose()
	}
	function contactWhatsApp() {
		// TODO: Add whatsapp logic
		return true
	}
	function submit() {
		$emit('submit')
	}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _unref(state).dialog,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(state).dialog) = $event)),
    width: _unref(width)
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        "min-width": _unref(width),
        "max-width": _unref(width)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { align: "center" }, {
                default: _withCtx(() => [
                  ($props.icon)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 0,
                        cols: "1",
                        class: "text-center pr-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            size: "small",
                            icon: $props.icon,
                            color: __props.iconColor
                          }, null, 8, ["icon", "color"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_col, {
                    cols: $props.icon ? 9 : 10,
                    class: "text-h6"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t($props.title)), 1)
                    ]),
                    _: 1
                  }, 8, ["cols"]),
                  _createVNode(_component_v_col, {
                    cols: "2",
                    class: "text-right"
                  }, {
                    default: _withCtx(() => [
                      (!__props.noClose)
                        ? (_openBlock(), _createBlock(AButtonIcon, {
                            key: 0,
                            icon: _unref(icons)['close'],
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (onClose()))
                          }, null, 8, ["icon"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _renderSlot(_ctx.$slots, "navigation"),
          _createVNode(_component_v_card_text, {
            class: _normalizeClass({ 'pb-0': $props.noActions })
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }, 8, ["class"]),
          ($props.premium)
            ? (_openBlock(), _createBlock(_component_v_card_actions, {
                key: 0,
                class: "pa-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(AButtonPrimary, {
                    block: "",
                    color: "premium",
                    text: _ctx.$t('General_request_information'),
                    icon: _unref(icons)['whatsapp'],
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (contactWhatsApp()))
                  }, null, 8, ["text", "icon"])
                ]),
                _: 1
              }))
            : (!!_ctx.$slots.actions)
              ? (_openBlock(), _createBlock(_component_v_card_actions, { key: 1 }, {
                  default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "actions")
                  ]),
                  _: 3
                }))
              : (!__props.noActions)
                ? (_openBlock(), _createBlock(_component_v_card_actions, { key: 2 }, {
                    default: _withCtx(() => [
                      ($props.reset)
                        ? (_openBlock(), _createBlock(AButtonSecondary, {
                            key: 0,
                            color: "error",
                            text: _ctx.$t(__props.resetAction),
                            icon: _unref(icons)['restart'],
                            disabled: $props.loading,
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (onReset()))
                          }, null, 8, ["text", "icon", "disabled"]))
                        : _createCommentVNode("", true),
                      ($props.emitDelete)
                        ? (_openBlock(), _createBlock(AButtonSecondary, {
                            key: 1,
                            color: "error",
                            text: _ctx.$t('Action_delete'),
                            icon: _unref(icons)['delete'],
                            disabled: $props.loading,
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (onDelete()))
                          }, null, 8, ["text", "icon", "disabled"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_spacer),
                      _createVNode(AButtonSecondary, {
                        color: "error",
                        text: _ctx.$t('Action_cancel'),
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (onCancel()))
                      }, null, 8, ["text"]),
                      _createVNode(AButtonPrimary, {
                        text: _ctx.$t(__props.action),
                        disabled: $props.disabled,
                        loading: $props.loading,
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (submit()))
                      }, null, 8, ["text", "disabled", "loading"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["min-width", "max-width"])
    ]),
    _: 3
  }, 8, ["modelValue", "width"]))
}
}

})